export type ProductListUi = {
  products: OrderDetailProductUi[];
};

export type OrderDetailProductUi = {
  id: string;
  image: string;
  name: string;
  presentation: string;
  pricing: string;
  quantity: string;
  totalAmount: string;
};

export const initialState: ProductListUi = {
  products: [],
};
